"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS = void 0;
var STATUS = {
  WAITING: -1,
  TIMEOUT: 0,
  ACTIVE: 100,
  SUCCESS: 200,
  FAIL: 400,
  NOT_FOUND: 404
};
exports.STATUS = STATUS;